module.exports = __webpack_public_path__ + "img/custom.0554c410.png";